<template>
  <div class="main-container">
    <!-- 
        moduleCode:
        活动汇总:ACTIVITY_SUMMARY
        行销工具:MARKET_TOOLS
        常用信息:COMMON_USE_TOOLS
        周边服务:PERIPHERY_SERVICE
        热点资讯:HOT_SPOT
       -->
    <div class="search-box">
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyId" clearable filterable>
          <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">活动名称</span>
        <Input type="text" v-model="searchParams.title" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">上架时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">文章类型</span>
        <Select v-model="searchParams.type" clearable>
          <Option value="1">图文</Option>
          <Option value="2">海报</Option>
          <Option value="3">PDF</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table ref="selection" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="title">
          <span class="table-btn" @click="openUrl(row)">{{ row.title }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="copyUrl(row)" v-if="row.type == 1">复制链接</span>
          <span class="table-btn" v-else @click="download(row)">下载</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        show-sizer
        :page-size-opts="[10, 20, 30, 50, 100]"
        @on-page-size-change="pageSizeChange"
        style="text-align: center"
      />
    </div>
    <!-- 海报预览 -->
    <div class="img-list">
      <img v-for="(bean, i) in previewImg" :key="bean.path" :src="bean.path" preview="img" :id="'img' + i" />
    </div>
    <!-- pdf预览 -->
    <pdf-view ref="pdfView" />
  </div>
</template>
  <script>
import { common, pageTool } from '@/api/mixins';
import { config } from './other.config.js';
import pdfView from '@/components/commons/pdfView';
export default {
  mixins: [common, pageTool, config],
  components: { pdfView },
  data: () => ({
    moduleCode: 'ACTIVITY_SUMMARY',
    previewImg: [],
    tabList: [], // tab列表
    companyList: [] // 保司列表
  }),
  mounted() {},
  created() {
    this.initListParams('/buz/articleBase/read/page');
    this.queryCompanyList();
  },
  activated() {
    if (this.moduleCode) {
      this.getList();
    }
  },
  methods: {
    // 打开页面
    openUrl(row) {
      const base = this.$config.h5Base;
      const url = base + '/apps/articelDetail?id=' + row.id;
      if (row.type == 1) {
        window.open(url);
      } else if (row.type == 2) {
        this.previewImg = row.fileUrlList;
        this.$nextTick(() => {
          this.$previewRefresh();
          window.setTimeout(() => {
            const event = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            document.getElementById('img0').dispatchEvent(event);
          }, 300);
        });
        // window.open(row.url);
      } else if (row.fileUrlList && row.fileUrlList.length) {
        // window.open(row.fileUrlList[0].path);
        this.$refs.pdfView.open(row.fileUrlList);
      }
    },
    // 下载
    download(row) {
      if (!row.fileUrlList || !row.fileUrlList.length) return;
      if (row.fileUrlList.length == 1) {
        this.$units.downloadFun({ url: row.fileUrlList[0].path });
      } else {
        this.$units.downloadFun({
          url: '/buz/articleBase/downAll',
          params: {
            id: row.id
          }
        });
      }
    },
    // 复制链接
    copyUrl(row) {
      const base = this.$config.h5Base;
      const url = base + '/apps/articelDetail?id=' + row.id;
      this.$units.copyUrl(url, true, true);
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    setListParams(params) {
      params.status = 1;
      params.moduleCode = this.moduleCode;
      if (params.date && params.date[0]) {
        params.useTimeStartTime = params.date[0] + ' 00:00:00';
        params.useTimeEndTime = params.date[1] + ' 23:59:59';
      }
      delete params.date;
      this.getColumns();
    }
  }
};
</script>
  <style lang='scss' scoped>
.img-list {
  position: absolute;
  z-index: -1;
  top: -99999px;
}
</style>